import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import { APP_CONFIG } from './app-config';
import { environment } from '@environments/environment';

export function provideAppConfig(): EnvironmentProviders {

  return makeEnvironmentProviders([
    { provide: APP_CONFIG, useValue: environment },
  ]);
}
